'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IDMention = require('../mentions/IDMention');

var _IDMention2 = _interopRequireDefault(_IDMention);

var _IDPercent = require('../percent/IDPercent');

var _IDPercent2 = _interopRequireDefault(_IDPercent);

var _IDRichText = require('../richtext/IDRichText');

var _IDRichText2 = _interopRequireDefault(_IDRichText);

var _IDTextArea = require('../textarea/IDTextArea');

var _IDTextArea2 = _interopRequireDefault(_IDTextArea);

var _IDCard = require('../textbox/IDCard');

var _IDCard2 = _interopRequireDefault(_IDCard);

var _IDEmail = require('../textbox/IDEmail');

var _IDEmail2 = _interopRequireDefault(_IDEmail);

var _IDNumber = require('../textbox/IDNumber');

var _IDNumber2 = _interopRequireDefault(_IDNumber);

var _IDPassword = require('../textbox/IDPassword');

var _IDPassword2 = _interopRequireDefault(_IDPassword);

var _IDPhone = require('../textbox/IDPhone');

var _IDPhone2 = _interopRequireDefault(_IDPhone);

var _IDUrl = require('../textbox/IDUrl');

var _IDUrl2 = _interopRequireDefault(_IDUrl);

var _IDTextbox = require('../textbox/IDTextbox');

var _IDTextbox2 = _interopRequireDefault(_IDTextbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    text: _IDTextbox2.default,
    textArea: _IDTextArea2.default,
    percent: _IDPercent2.default,
    password: _IDPassword2.default,
    phone: _IDPhone2.default,
    number: _IDNumber2.default,
    email: _IDEmail2.default,
    url: _IDUrl2.default,
    card: _IDCard2.default,
    mention: _IDMention2.default,
    richText: _IDRichText2.default
};

var IIInput = function IIInput(props) {
    var IInput = null;
    var type = props.type;

    if (type) {
        IInput = types[type];
    }
    if (!IInput) {
        return null;
    }
    return _react2.default.createElement(IInput, (0, _extends3.default)({}, props, {
        fromIDInput: true,
        ref: props.forwardRef
    }));
};

IIInput.defaultProps = {
    type: 'text'
};

var IDInput = _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(IIInput, (0, _extends3.default)({}, props, { forwardRef: ref }));
});
exports.default = IDInput;